export type StorageFactorKey =
  | 'storageFactorPointCloud' | 'storageFactorGaussian' | 'storageFactor2d' | 'storageFactor3d'
  | 'storageFactorOrthomosaic' | 'storageFactorVideo360';

/** The Unit prices field that holds each file type's storage factor. */
export const FACTOR_RATE_KEY: Record<string, StorageFactorKey> = {
  point_cloud: 'storageFactorPointCloud',
  gaussian: 'storageFactorGaussian',
  '2d': 'storageFactor2d',
  '3d': 'storageFactor3d',
  orthomosaic: 'storageFactorOrthomosaic',
  video360: 'storageFactorVideo360',
};

// A handful of files says more about those files than about the type.
export const FACTOR_MIN_FILES = 10;
// Closer than this, a change would not move the calculator's storage noticeably.
export const FACTOR_TOLERANCE = 0.03;

export type FactorAdvice =
  | { kind: 'none' }
  | { kind: 'few'; files: number }
  | { kind: 'keep' }
  | { kind: 'unsaved' }
  | { kind: 'change'; value: number };

/**
 * What to do with a type's storage factor, given what the bucket measured,
 * the value saved in Unit prices and the one in the form now.
 */
export function factorAdvice(
  measuredOver: { files: number; measured: number }, saved: number, inForm?: number,
): FactorAdvice {
  const { files, measured } = measuredOver;
  if (!files || measured <= 0) return { kind: 'none' };
  if (files < FACTOR_MIN_FILES) return { kind: 'few', files };
  if (saved > 0 && Math.abs(measured - saved) / saved <= FACTOR_TOLERANCE) return { kind: 'keep' };
  if (inForm != null && Math.abs(inForm - measured) < 0.005) return { kind: 'unsaved' };
  return { kind: 'change', value: measured };
}
